import React from 'react'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'

import './index.scss'

interface IArrowForwardRequired {
	isActive: boolean
}

interface IArrowForwardOptional {
	className?: string
}

interface IArrowForwardProps
	extends IArrowForwardOptional,
		IArrowForwardRequired {}

const ArrowForward: React.FC<IArrowForwardProps> = ({
	isActive,
	className = '',
}) => (
	<ArrowForwardIosIcon
		className={`${className} arrow-forward ${
			isActive ? 'arrow-forward_active' : ''
		}`}
	/>
)

export default ArrowForward
